import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE } from "./PhoneButton";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 pt-16 pb-32 md:pb-16"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        {/* Top: brand + repeated phone */}
        <div className="grid lg:grid-cols-12 gap-10 pb-12 border-b border-slate-800">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-amber-400 text-blue-900 font-serif-display font-black text-2xl">
                A
              </span>
              <span className="font-serif-display font-bold text-white text-xl md:text-2xl">
                Affordable Life Coverage
              </span>
            </div>
            <p className="mt-5 text-lg leading-relaxed text-slate-400 max-w-md">
              Helping seniors on fixed incomes find the most affordable life
              insurance from 30+ top-rated carriers. One simple call.
            </p>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.22em] font-semibold text-amber-300">
              Speak to a licensed agent
            </p>
            <a
              href={PHONE.href}
              data-testid="footer-call-link"
              aria-label={`Call us at ${PHONE.display}`}
              className="mt-3 inline-flex items-center gap-4 group"
            >
              <Phone className="h-9 w-9 md:h-10 md:w-10 text-green-400 fill-green-400/20" />
              <span className="font-serif-display font-bold text-white text-4xl md:text-6xl group-hover:text-amber-300 transition-colors">
                {PHONE.display}
              </span>
            </a>
            <p className="mt-3 text-base text-slate-400">
              Monday – Saturday • 8 AM – 9 PM ET
            </p>
          </div>
        </div>

        {/* Middle: links + disclaimers */}
        <div className="grid md:grid-cols-3 gap-10 py-12 border-b border-slate-800 text-base">
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Coverage</h4>
            <ul className="space-y-2 text-slate-400">
              <li>Final Expense Insurance</li>
              <li>Term Life Insurance</li>
              <li>Whole Life Insurance</li>
              <li>Guaranteed Issue</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-slate-400">
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-green-400" />
                <a href={PHONE.href} className="hover:text-white">
                  {PHONE.display}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-green-400" />
                <span>support@affordablelifecoverage.com</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-green-400" />
                <span>Serving all 50 states</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Licensing</h4>
            <p className="text-slate-400 leading-relaxed">
              Affordable Life Coverage is a licensed insurance agency operating
              in all 50 states. All agents are state-licensed in the
              jurisdictions where they conduct business.
            </p>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="py-10 text-sm text-slate-500 leading-relaxed">
          <p>
            <strong className="text-slate-400">Disclaimer:</strong> Affordable
            Life Coverage is a private licensed insurance agency. We are{" "}
            <strong>not affiliated</strong> with Medicare, the Social Security
            Administration, or any federal government program. Coverage,
            availability, and rates vary by state, age, and health status. Plans
            described are offered through our partner carriers; final terms are
            governed by the policy issued by the underwriting insurer.
            Guaranteed-issue products may include graded death benefits during
            the first two policy years.
          </p>
          <p className="mt-4">
            By calling the number listed, you may be connected to a licensed
            insurance agent who can answer questions about life insurance
            products. Calls may be recorded for quality and training purposes.
          </p>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-slate-500 border-t border-slate-800">
          <p>© 2026 Affordable Life Coverage. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
